var React = require('react');

function LogoTinyA (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1405.619 794.95v.089h-8.559v-2.661c-1.419 1.2-3.814 2.883-5.809 2.883a5.278 5.278 0 0 1 -5.631-5.277c0-3.282 1.95-4.7 5.809-6.962 4.257-2.528 5.809-3.726 5.809-6.342 0-1.862-.886-3.414-2.572-3.414-2.394 0-6.43 3.636-8.026 5.055l-.089-.089 3.681-4.923a41.588 41.588 0 0 1 7.184-.754c4.391 0 5.854 2.395 5.854 5.188v11.885c-.002 2.351.087 4.125 2.349 5.322zm-8.559-4.878v-10.332c-4.39 3.592-5.5 4.257-5.5 8.825 0 2.7 1.641 4.523 3.015 4.523s2.485-1.109 2.485-3.016zm-3.593-19.072h-.177a14.96 14.96 0 0 0 2.794-7.007h5.943c-1.952 3.95-6.076 6.079-8.56 7.007z","fill":"#8e9883","transform":"translate(-1385.619 -763.996)"}));
}

LogoTinyA.defaultProps = {"height":"31.265","viewBox":"0 0 20 31.265","width":"20"};

module.exports = LogoTinyA;

LogoTinyA.default = LogoTinyA;
